import React from 'react';

export type IconName =
  | 'phone' | 'download' | 'menu' | 'plus' | 'x' | 'arrow-right' | 'arrow-down' | 'chevron-left' | 'chevron-right'
  | 'chevron-down' | 'shield' | 'pin' | 'timer' | 'search' | 'message' | 'chat' | 'users' | 'lock' | 'eye-off'
  | 'check' | 'check-circle' | 'exit' | 'bell' | 'book' | 'gauge' | 'quiz' | 'heart' | 'history' | 'home' | 'nav'
  | 'mail' | 'info' | 'alert' | 'refresh' | 'smartphone' | 'sos' | 'sparkle' | 'leaf' | 'google-play' | 'apple';

/** Draws one symbol of /assets/sprite.svg. Decorative: the label always sits next to it. */
const Icon: React.FC<{ name: IconName; className?: string }> = ({ name, className }) => (
  <svg className={className ? `icon ${className}` : 'icon'} aria-hidden="true" focusable="false">
    <use href={`/assets/sprite.svg#i-${name}`} />
  </svg>
);

export default Icon;
